module.exports = __webpack_public_path__ + "img/授業風景のアイコン.e88bc177.svg";